import React from 'react';
import PropTypes from 'prop-types';
import { BarLoader } from 'react-spinners';
import styled from 'styled-components';
import theme from 'styles/theme';

const ThemePageLoaderWrapper = styled.div`
  height: 200px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const ThemePageLoader = styled(({ ...others }) => <BarLoader {...others} />)``;

/**
 *
 * @param {bool} isLoadable - a bool to that uses Loadable func from react-loadable
 */
const PageLoader = ({ isLoadable, pastDelay, ...others }) => {
  const renderLoader = () => {
    return (
      <ThemePageLoaderWrapper>
        <ThemePageLoader {...others} />
      </ThemePageLoaderWrapper>
    );
  };

  const renderLoadable = () => {
    return <>{pastDelay ? renderLoader() : null}</>;
  };

  return <>{isLoadable ? renderLoadable() : renderLoader()}</>;
};

PageLoader.propTypes = {
  isLoadable: PropTypes.bool,
};

PageLoader.defaultProps = {
  sizeUnit: 'px',
  size: 200,
  width: 150,
  color: theme.palette.primary,
};

export default PageLoader;
